export default {
  navHome: "Beranda",
  navProducts: "Produk",
  navCases: "Studi Kasus Aplikasi",
  navAbout: "Tentang Kami",
  deliverTo: "Kirim ke:",
  langCurrencyLabel: "Bahasa Indonesia",
  localeLangTitle: "Atur bahasa",
  localeLangDesc:
    "Pilih bahasa pilihan Anda. Anda dapat memperbarui pengaturan ini kapan saja.",
  language: "Bahasa",
  save: "Simpan",
  coreProducts: "Memberdayakan kreativitas di dunia nyata.",
  coreProductsDesc:
    "Dari ide ke bisnis �?YONGYUAN menyediakan printer UV, printer label kristal, printer silinder berkecepatan tinggi, printer DTF dan DTG, mengubah kreativitas menjadi produk, merek, dan peluang.",
  scenariosTitle: "Solusi untuk setiap skenario",
  scenariosDesc:
    "Baik Anda membangun merek, mengembangkan bisnis sampingan, atau mengejar hasrat kreatif, YONGYUAN menawarkan solusi yang disesuaikan dengan kebutuhan Anda.",
  scenarioStudio: "Studio",
  scenarioStudioDesc:
    "Kustomisasi bernilai tinggi, prototipe batch kecil, dan pembangunan merek",
  scenarioRetail: "Retail merek",
  scenarioRetailDesc:
    "Perpanjang waktu tinggal pelanggan dan tingkatkan pendapatan toko",
  scenarioMarket: "Pasar pop-up",
  scenarioMarketDesc:
    "Kustomisasi di tempat, penjualan produk jadi, dan pendapatan tambahan",
  scenarioEnterprise: "Kustomisasi perusahaan",
  scenarioEnterpriseDesc:
    "Kustomisasi batch, merchandise merek, dan hadiah korporat",
  scenarioEcommerce: "Penjualan livestream",
  scenarioEcommerceDesc:
    "Sampel produk hit, pasokan fleksibel, dan peluncuran produk cepat",
  scenarioStore: "Toko e-commerce",
  scenarioStoreDesc:
    "Kustomisasi toko, merchandise hit, dan operasi yang berbeda",
  scenarioFactory: "Produksi pabrik",
  scenarioFactoryDesc:
    "Manufaktur batch, output stabil, dan operasi hemat biaya",
  scenarioAdvertising: "Produksi iklan",
  scenarioAdvertisingDesc:
    "Papan nama, bahan display, dan materi acara",
  industries: "Aplikasi industri",
  industriesDesc:
    "Solusi cetak inkjet digital untuk cetak warna di berbagai industri.",
  applicationsTitle:
    "Buka aplikasi material dan warna serbaguna untuk kebutuhan sehari-hari dan komersial.",
  applicationsDesc:
    "Peralatan cetak UV YONGYUAN dirancang untuk berbagai material dan skenario proses, mendukung kustomisasi personal dan produksi skala besar.",
  casesHeroDesc:
    "Mencakup 1200+ aplikasi industri dan puluhan ribu material yang dapat dicetak — solusi cetak digital untuk berbagai bisnis.",
  casesBreadcrumbHome: "Beranda",
  casesBreadcrumbCenter: "Studi Kasus Aplikasi",
  casesEmpty: "Belum ada studi kasus aplikasi dalam kategori ini.",
  customerStoriesTitle: "Dipercaya oleh Pelanggan di Seluruh Dunia",
  customerStoriesSubtitle:
    "Instalasi nyata, pelanggan nyata, bisnis printing nyata di 172 negara.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Printer yang dikirim",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Negara dilayani",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Tahun pengalaman",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Dukungan teknis",
  customerStoriesPlaceholder: "Tambah foto pelanggan",
  customerStoriesPhotoAlt: "Pelanggan YONGYUAN dengan printer",
  servicePartnerTitle:
    "Kenali tim layanan YONGYUAN, mitra kreatif Anda",
  servicePartnerDesc:
    "Jaringan layanan global dan sistem dukungan profesional untuk melindungi kinerja peralatan dan pertumbuhan bisnis Anda.",
  serviceSupportTitle: "Dukungan standar",
  serviceSupportDesc:
    "Panduan instalasi, pelatihan dasar, dan bantuan penggunaan harian untuk operasi yang andal.",
  servicePresaleTitle: "Demo dan konsultasi pra-penjualan",
  servicePresaleDesc:
    "Demonstrasi solusi dan rekomendasi model yang disesuaikan dengan skenario aplikasi dan kebutuhan kapasitas Anda.",
  serviceLifetimeTitle: "Dukungan teknis seumur hidup",
  serviceLifetimeDesc:
    "Respons teknis berkelanjutan dan dukungan proses untuk mendampingi pengembangan bisnis jangka panjang Anda.",
  serviceCareTitle: "Upgrade ke YONGYUAN Care",
  serviceCareDamageTitle: "Perlindungan kerusakan akidental",
  serviceCareDamageDesc:
    "Rencana perlindungan yang lebih komprehensif untuk mengurangi kerugian akibat insiden tak terduga.",
  serviceCareExchangeTitle: "Layanan tukar cepat",
  serviceCareExchangeDesc:
    "Pengaturan tukar cepat prioritas dalam kondisi yang memenuhi syarat untuk mempercepat pemulihan modal.",
  viewProduct: "Lihat produk",
  learnMore: "Pelajari lebih lanjut",
  catUv: "Printer UV datar",
  catCylinder: "Printer silinder",
  catCrystal: "Printer label kristal",
  catDtf: "Printer DTF",
  catDtg: "Printer DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Telepon: 17748697567 Manajer Tang",
  email: "Email: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Hak cipta dilindungi",
  productsHeroTitle: "Produk",
  productsHeroDesc:
    "Lini lengkap peralatan UV datar, silinder, label kristal, DTF, dan DTG untuk berbagai kebutuhan kapasitas dan aplikasi.",
  productsBreadcrumbHome: "Beranda",
  productsBreadcrumbCenter: "Produk",
  productsEmpty: "Produk dalam kategori ini segera hadir.",
  productsQuoteTitle: "Minta solusi dan penawaran",
  productsQuoteDesc:
    "Bagikan skenario aplikasi dan kebutuhan kapasitas Anda, kami akan merekomendasikan solusi peralatan yang tepat.",
  productsContact: "Hubungi kami",
  aboutHeroTitle: "Tentang Yongyuan",
  aboutHeroDesc:
    "23 tahun fokus pada R&D dan produksi peralatan cetak UV",
  productA23Subtitle: "Printer UV cerdas 6 warna desktop",
  productA23Feature1: "Format cetak A4",
  productA23Feature2: "Sistem pasokan tinta cerdas",
  productA23Feature3: "Deteksi ketinggian otomatis inframerah",
  productA35Subtitle: "Printer UV cerdas 6 warna desktop",
  productA35Feature1: "Format cetak A3+",
  productA35Feature2: "Sistem pasokan tinta cerdas",
  productA35Feature3: "Deteksi ketinggian otomatis inframerah",
  productA43Subtitle: "Printer UV cerdas 8 warna flagship",
  productA43Feature1: "Format cetak A3",
  productA43Feature2: "Beberapa konfigurasi kepala cetak",
  productA43Feature3: "Sistem pasokan tinta cerdas",
  productA46Subtitle: "Printer UV cerdas 8 warna flagship",
  productA46Feature1: "Format cetak A2",
  productA46Feature2: "Beberapa konfigurasi kepala cetak",
  productA46Feature3: "Sistem pasokan tinta cerdas",
  productA57Subtitle: "Printer UV cerdas 8 warna flagship",
  productA57Feature1: "Format cetak A2+",
  productA57Feature2: "Beberapa konfigurasi kepala cetak",
  productA57Feature3: "Sistem pasokan tinta cerdas",
  productA69Subtitle: "Printer UV cerdas 8 warna flagship",
  productA69Feature1: "Format cetak A1",
  productA69Feature2: "Beberapa konfigurasi kepala cetak",
  productA69Feature3: "Sistem pasokan tinta cerdas",
  productA1216Subtitle: "Printer UV datar format besar flagship",
  productA1216Feature1: "Format cetak 1200×1600cm",
  productA1216Feature2: "Beberapa konfigurasi kepala cetak",
  productA1216Feature3: "Sistem pemosisian visual",
  productA2513Subtitle: "Printer UV datar format besar flagship",
  productA2513Feature1: "Format cetak 2500×1300cm",
  productA2513Feature2: "Beberapa konfigurasi kepala cetak",
  productA2513Feature3: "Sistem pemosisian visual",
  productCylinderElfSubtitle: "Printer silinder berkecepatan tinggi 360°",
  productCylinderElfFeature1: "Cetak 360°",
  productCylinderElfFeature2: "Kustomisasi cangkir dan botol",
  productCylinderElfFeature3: "Pergantian fixture cepat",
  productCupPlusSubtitle: "Solusi cetak cangkir dan botol multi-ukuran",
  productCupPlusFeature1: "Fixture multi-ukuran",
  productCupPlusFeature2: "Efisiensi produksi tinggi",
  productCupPlusFeature3: "Output stabil",
  productCrystal60Subtitle: "Sistem all-in-one cetak dan foil label kristal",
  productCrystal60Feature1: "Lebar 60cm",
  productCrystal60Feature2: "Integrasi cetak dan foil",
  productCrystal60Feature3: "Sistem pengambilan efisien",
  productCrystalC60UltraFeature1: "Lebar 60 cm",
  productCrystalC60UltraFeature2: "Opsi foil emas/perak/label silikon 3D",
  productCrystalC60UltraFeature3: "Produksi massal",
  productCrystal30Subtitle: "Printer label kristal presisi tinggi kompak",
  productCrystal30Feature1: "Cetak presisi kompak",
  productCrystal30Feature2: "Mudah dioperasikan",
  productCrystal30Feature3: "Kustomisasi personal",
  productDtf60Subtitle: "Printer transfer DTF tinta putih",
  productDtf60Feature1: "Transfer DTF tinta putih",
  productDtf60Feature2: "Lapisan warna kaya",
  productDtf60Feature3: "Aksesori pakaian",
  productDtfF20Subtitle: "Printer DTF tinta putih desktop terkecil di industri",
  productDtfF20Feature1: "Ukuran A4",
  productDtfF20Feature2: "Kustomisasi batch kecil",
  productDtfF20Feature3: "Sistem tinta cerdas",
  productDtfF30Subtitle: "Printer DTF tinta putih desktop",
  productDtfF30Feature1: "Ukuran A3",
  productDtfF30Feature2: "Kepala tunggal manual/otomatis opsional",
  productDtfF30Feature3: "Sistem tinta cerdas",
  productDtfF30ProSubtitle: "Printer DTF tinta putih",
  productDtfF30ProFeature1: "Ukuran A3",
  productDtfF30ProFeature2: "Konfigurasi dual head dengan penggulungan film otomatis",
  productDtfF30ProFeature3: "Sistem tinta cerdas",
  productDtfF33Subtitle: "Printer DTF tinta putih",
  productDtfF33Feature1: "Ukuran A3",
  productDtfF33Feature2: "Kepala tunggal manual/otomatis opsional",
  productDtfF33Feature3: "Sistem tinta cerdas",
  productDtfF70ProSubtitle: "Printer DTF tinta putih format lebar 70 cm",
  productDtfF70ProFeature1: "Ukuran A2",
  productDtfF70ProFeature2: "Opsi 2�? kepala cetak",
  productDtfF70ProFeature3: "Sistem pakan dan keluaran otomatis",
  productDtfF70ProFeature4: "Mode lanjut cetak cerdas",
  productDtf30Subtitle: "Printer DTF tinta putih kompak",
  productDtf30Feature1: "Kustomisasi batch kecil",
  productDtf30Feature2: "Reproduksi warna akurat",
  productDtf30Feature3: "Mudah digunakan",
  productDtgPrintSubtitle: "Printer digital langsung ke kain",
  productDtgPrintFeature1: "Cetak langsung multi-material",
  productDtgPrintFeature2: "Throughput tinggi",
  productDtgPrintFeature3: "Stabil dan tahan lama",
  productDtg3250DSubtitle: "Satu-satunya model DTF & DTG 2-in-1 di industri",
  productDtg3250DFeature1: "Format A3+",
  productDtg3250DFeature2: "Mode cetak dual DTF & DTG",
  productDtg3250DFeature3: "Sistem tinta cerdas",
  productDtg3646TSubtitle: "Printer DTG dual-station",
  productDtg3646TFeature1: "Mode produksi berkelanjutan",
  productDtg3646TFeature2: "Peningkatan produktivitas 100%",
  productDtg3646TFeature3: "Sistem tinta cerdas",
  productDtgMaxSubtitle: "Printer DTG digital industri",
  productDtgMaxFeature1: "Kapasitas industri",
  productDtgMaxFeature2: "Stabil dan tahan lama",
  productDtgMaxFeature3: "Operasi berkelanjutan",
  app01Title: "Casing ponsel",
  app02Title: "Bola golf",
  app03Title: "Plakat batu",
  app04Title: "Pulpen",
  app05Title: "Tempat kacamata",
  app06Title: "Cetakan kayu",
  app07Title: "Kaleng minuman",
  app08Title: "Keyboard",
  app09Title: "Tumbler",
  app10Title: "Koper",
  app11Title: "Produk akrilik",
  app12Title: "Buku catatan",
  app13Title: "Lencana",
  app14Title: "Dompet kartu kulit",
  app15Title: "Plat identitas",
  app16Title: "Seni kaca",
  appDtgCase01: "Kaos",
  appDtgCase02: "Hoodie",
  regionCn: "Tiongkok",
  regionUs: "Amerika Serikat",
  regionGb: "Britania Raya",
  regionDe: "Jerman",
  regionAe: "UEA",
  regionIn: "India",
  regionJp: "Jepang",
  regionVn: "Vietnam",
  regionBr: "Brasil",
  regionAu: "Australia",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
